import React, { useEffect, useState } from "react";
import Popup from "../../../../../../components/Popup";
import SelectGroup from "../../../../../../components/SelectGroup";

import "./styles.css"

export default function SelectBankAccountsPopUp(props) {
    const [contasBancarias, setContasBancarias] = useState([]);

    useEffect(() => {
        setContasBancarias(props.contasBancarias);
    }, [props.contasBancarias]);

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            tittle="Contas Bancárias"
        >
            <SelectGroup
                single={false}
                hides={[]}
                markeds={contasBancarias}
                setMarkeds={setContasBancarias}
            >
                {
                    props.bankAccounts.filter(item => props.currency && item.moeda === props.currency).map(bankAccount => {
                        return (
                            <div key={bankAccount.id} className="companie-popup-bank-account-container">
                                <p>{`Banco: ${bankAccount.banco}, Agência: ${bankAccount.agencia}, Conta: ${bankAccount.numero}`}</p>
                            </div>
                        )
                    })
                }
            </SelectGroup>
            <button onClick={() => {
                props.setContasBancarias(contasBancarias);
                props.setVisibility(false);
            }}>Selecionar</button>
        </Popup>
    );
}